import React from "react";
import { Trans } from "@elevio/kb-kit/lib/components/trans";
function Loader() {
    return (<main className="page-loader" aria-label="Loading content">
      <Trans i18nKey="loading">Loading</Trans>
    </main>);
}
export default Loader;
